<template>
  <AddFamilyTemplate :header="header">
    <template #content>
      <div>
        <AddFamilyConsent
          ref="consentForm"
          :internal="true"
          @fileChanges="checkboxTransition($event)"
        />
        <transition name="fade">
          <v-layout
            v-show="showCheckbox"
            justify-center
          >
            <v-flex
              xs10
              sm8
            >
              <CRZConsents
                :JSONFileName="INTERNAL_FAMILY_TO_ACCEPT_CONSENT_TYPE"
                @selectedConsents="consents = $event"
              />
            </v-flex>
          </v-layout>
        </transition>
      </div>
    </template>
    <template #actions>
      <v-layout
        v-if="isFormValid === false"
        mb-0
        mt-3
      >
        <v-flex>
          <div class="v-message text-xs-center">
            <div class="v-messages__message">
              {{ $t('errors.form_not_valid') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout
        align-center
        justify-end
        wrap
        :justify-center="$vuetify.breakpoint.xs"
      >
        <v-flex
          shrink
          :mr-4="$vuetify.breakpoint.smAndUp"
          order-xs2
          order-sm1
          :mt-2="$vuetify.breakpoint.xs"
        >
          <router-link
            :to="{ name: 'families-to-accept' }"
            class="link_iconed"
          >
            <v-icon>chevron_left</v-icon>
            {{ $t('buttons.return_to_families_list') }}
          </router-link>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            color="sz_violet"
            @click="nextStep()"
          >
            {{ $t('buttons.next_button') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </AddFamilyTemplate>
</template>

<script>
import CRZConsents from '@/components/widgets/CRZConsents';
import AddFamilyTemplate from '@/components/addFamily/AddFamilyTemplate';
import AddFamilyConsent from '@/components/addFamily/AddFamilyConsent';
import validationRules from '@/constants/validationRules';
import { mapFields } from 'vuex-map-fields';
import { INTERNAL_FAMILY_TO_ACCEPT_CONSENT_TYPE } from '@/constants/JSONFileName';

export default {
    name: 'FamilyConsent',
    components: { AddFamilyConsent, AddFamilyTemplate, CRZConsents },
    data () {
        return {
            validationRules,
            isFormValid: true,
            showCheckbox: false,
            INTERNAL_FAMILY_TO_ACCEPT_CONSENT_TYPE
        };
    },
    computed: {
        header () {
            return {
                title: this.$t('add_family.page_title'),
                subtitle: this.$t('outside_family.header_subtitles.consent')
            };
        },
        ...mapFields('familyData', ['consents'])
    },
    methods: {
        nextStep () {
            this.$validator.validateAll().then((result) => {
                const consentValidation = this.$refs.consentForm.submit();
                if (result && consentValidation) {
                    this.isFormValid = true;
                    this.$router.push({ name: 'family-details' });
                } else {
                    this.isFormValid = false;
                }
            });
        },
        checkboxTransition (event) {
            setTimeout(() => {
                this.showCheckbox = event;
            }, 450);
        }
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
